import React, { useState, useEffect } from 'react';
import './Testimonials.css';

// Import local testimonial images
import mohammed_chaib from './images/mohammed_chaib.jpg';
/*import michaelChen from './images/michael_chen.jpg';
import margaretWilliams from './images/margaret_williams.jpg';*/

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      text: 'At 12, I thought coding was impossible. AMALIKA WORLD made it fun and easy! Now I\'m building my own games and teaching my grandpa too!',
      author: 'Uncle Madjide',
      role: 'Age 12, Young Programmer',
      avatar: mohammed_chaib,
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    },
    {
      id: 2,
      text: 'Learning French at 45 seemed daunting, but the patient instructors and clear lessons made it enjoyable. Now I\'m planning a trip to Paris!',
      author: 'Uncle Madjide',
      role: 'Age 45, Language Enthusiast',
      avatar: mohammed_chaib,
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
    },
    {
      id: 3,
      text: 'At 67, I never thought I\'d learn robotics. The step-by-step approach and supportive community made it possible. I built my first robot!',
      author: 'Uncle Madjide',
      role: 'Age 67, Robotics Student',
      avatar: mohammed_chaib,
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveTestimonial(prev => (prev + 1) % testimonials.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section className="section testimonials-new" id="testimonials">
      <div className="container">
        {/* Header */}
        <div className="testimonials-header-new">
          <h2 className="section-title-new">Success Stories from All Ages</h2>
          <p className="section-subtitle-new">
            Hear from our diverse community of learners spanning generations
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="testimonials-grid-new">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card-new ${index === activeTestimonial ? 'active' : ''}`}
              style={{ '--gradient': testimonial.gradient }}
              onClick={() => setActiveTestimonial(index)}
            >
              <div className="card-content-new">
                {/* Avatar - Updated to use local image */}
                <div className="avatar-container-new">
                  <div className="avatar-circle-new">
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.author}
                      className="avatar-image-new"
                      onError={(e) => {
                        // Fallback if image fails to load
                        e.target.style.display = 'none';
                        const fallback = document.createElement('span');
                        fallback.className = 'avatar-emoji-fallback';
                        fallback.textContent = '👤';
                        e.target.parentNode.appendChild(fallback);
                      }}
                    />
                  </div>
                </div>

                {/* Quote */}
                <div className="quote-icon-new">
                  <i className="fas fa-quote-left"></i>
                </div>

                {/* Text */}
                <p className="testimonial-text-new">{testimonial.text}</p>

                {/* Author */}
                <div className="author-info-new">
                  <h4 className="author-name-new">{testimonial.author}</h4>
                  <p className="author-role-new">{testimonial.role}</p>
                </div>

                {/* Decorative Elements */}
                <div className="decorations-new">
                  <div className="decoration-1"></div>
                  <div className="decoration-2"></div>
                  <div className="decoration-3"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Dots */}
        <div className="navigation-dots-new">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot-new ${index === activeTestimonial ? 'active' : ''}`}
              onClick={() => setActiveTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>

        {/* Stats */}
        <div className="stats-section-new">
          <div className="stat-item-new">
            <div className="stat-number-new">500+</div>
            <div className="stat-label-new">Success Stories</div>
          </div>
          <div className="stat-item-new">
            <div className="stat-number-new">98%</div>
            <div className="stat-label-new">Satisfaction Rate</div>
          </div>
          <div className="stat-item-new">
            <div className="stat-number-new">10-80</div>
            <div className="stat-label-new">Age Range</div>
          </div>
          <div className="stat-item-new">
            <div className="stat-number-new">50+</div>
            <div className="stat-label-new">Countries</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;